import { render } from "./ArchivedAds.vue?vue&type=template&id=f08ec184&scoped=true"
import script from "./ArchivedAds.vue?vue&type=script&lang=js"
export * from "./ArchivedAds.vue?vue&type=script&lang=js"

import "./ArchivedAds.vue?vue&type=style&index=0&id=f08ec184&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f08ec184"]])

export default __exports__